/* Abajo, centrada (mock "Klavia Visitas"): no se cruza con el pie de un
   `Drawer` abierto a la derecha ni con la barra de acciones de un formulario. */
.region {
  position: fixed;
  left: 50%;
  bottom: var(--s-8);
  transform: translateX(-50%);
  z-index: var(--z-toast);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--s-4);
  pointer-events: none;
}
.item {
  pointer-events: auto;
  animation: entrar var(--dur-base) var(--ease-out);
}
@keyframes entrar {
  from {
    opacity: 0;
    transform: translateY(var(--s-3));
  }
  to {
    opacity: 1;
    transform: none;
  }
}

@media (max-width: 767px) {
  .region {
    left: 0;
    right: 0;
    bottom: auto;
    top: var(--s-5);
    transform: none;
    padding: 0 var(--s-5);
  }
}

@media (prefers-reduced-motion: reduce) {
  .item {
    animation: none;
  }
}
